export const buildOAuthTokenBody = (
  username: string,
  password: string
): { username: string; password: string } => {
  return { username, password }
}
